<style lang="scss" scoped>
.tile {
	text-align: center;
	cursor: pointer;
	position: relative;
	i {
		display: none;
	}
	&:hover {
		i {
			display: block !important;
		}
	}
	&__icon {
		width: 100%;
		height: auto;
		border-radius: 10px;
		background: white;
	}
	&__heading {
		margin-top: 15px;
		margin-top: 15px;
		margin-left: auto;
		margin-right: auto;
		text-overflow: ellipsis;
		text-align: center;
		width: 12ch;
		overflow: hidden;
		height: 70px;
		line-height: 23px;
	}
	&__delete {
		position: absolute;
		top: 0;
		right: -2px;
		height: 25px;
		width: 25px;
		line-height: 25px;
		text-align: center;
		font-size: 20px;
		background: red;
		color: white;
		border-bottom-left-radius: 5px;
		border-top-right-radius: 5px;
	}
	.image-container {
		height: 150px;
		border-radius: 10px;
		background: white;
	}
}
</style>

<template lang="pug">
    .tile(@click='launch')
        i(v-if="deletable && (app.association_uuid || app.classroom_uuid)", @click.stop="deleteTile").fe.fe-x.tile__delete
        .image-container
            IconImage(:icon="app.Icon", :size="150").tile__icon
        h3.tile__heading {{ app.application_name || app.name }}
</template>

<script>
import gql from "graphql-tag";
import tracker from "@/utils/event-tracker";
import { isUuid } from "@/utils/common";
import IconImage from "@/components/ui/IconImage";
import RomoveMixin from "@/components/apps/tile/Remove.mixin";

export default {
	components: {
		IconImage
	},
	mixins: [RomoveMixin],
	props: {
		app: {
			required: true,
			type: Object
		},
		deletable: {
			type: Boolean,
			default: false
		},
		classroom: {
			type: String,
			default: null
		}
	},
	methods: {
		async deleteTile() {
			if (this.app.classroom_uuid) {
				return this.deleteCompanyCustomTile();
			}

			this.deleteCompanyAssociation();
		},
		async deleteCompanyCustomTile() {
			await this._removeTile(this.app, this.classroom);
		},
		async deleteCompanyAssociation() {
			try {
				await this.$confirm("Are you sure you want to remove this application?", "Warning", {
					confirmButtonText: "Remove",
					cancelButtonText: "Cancel"
				});

				await this.$apollo.mutate({
					mutation: gql`
						mutation RemoveTile($uuid: String!) {
							RemoveTile(uuid: $uuid)
						}
					`,
					variables: {
						uuid: this.app.association_uuid
					},
					update: (store, { data: { RemoveTile } }) => {
						if (!RemoveTile) return;

						const userQuery = gql`
							query getUser($classUuid: String!) {
								User {
									id
									Companies(classroom_uuid: $classUuid) {
										id
										association_uuid
									}
								}
							}
						`;

						const variables = {
							classUuid: this.classroom
						};

						const userData = store.readQuery({
							query: userQuery,
							variables
						});

						userData.User.Companies = userData.User.Companies.filter(company => company.association_uuid !== this.app.association_uuid);
						store.writeQuery({ query: userQuery, variables, data: userData });

						try {
							const companyQuery = gql`
								query Companies {
									Companies {
										id
									}
								}
							`;

							const companyData = store.readQuery({ query: companyQuery });

							companyData.Companies = companyData.Companies.filter(company => company.id !== this.app.id);
							store.writeQuery({ query: companyQuery, data: companyData });
						} catch (error) {
							return;
						}
					}
				});

				this.$message.success("Application removed");

				tracker("application-removed", {
					application_name: this.app.name,
					application_id: this.app.id,
					application_association_id: this.app.association_uuid
				});
			} catch (error) {
				console.error("error", error);
			}
		},
		launch() {
			if (isUuid(this.app.id)) {
				tracker("launch-custom-tile", {
					tile_id: this.app.id,
					tile_name: this.app.name
				});
			} else {
				tracker("launch-app", {
					application_id: this.app.id,
					application_name: this.app.name
				});
			}

			if (this.app.launch_url) {
				this.loadHyperlink();
			} else if (this.app.sso_active) {
				this.loadSingleSignOn();
			} else {
				this.loadSavedPassword();
			}
		},
		loadHyperlink() {
			window.open(this.app.launch_url);
		},
		loadSavedPassword() {
			let routeData = this.$router.resolve({ name: "saved-password", params: { company: this.app.slug } });
			window.open(routeData.href, "_blank");
		},
		loadSingleSignOn() {
			let routeData = this.$router.resolve({
				name: "authorize",
				query: {
					redirect_uri: this.app.redirect,
					client_id: this.app.client_id
				}
			});
			window.open(routeData.href, "_blank");
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/employee/Tile.vue